export var Variants;
(function (Variants) {
    Variants["filled"] = "filled";
    Variants["outlined"] = "outlined";
})(Variants || (Variants = {}));
export var Types;
(function (Types) {
    Types["neutral"] = "neutral";
    Types["primary"] = "primary";
    Types["success"] = "success";
    Types["warning"] = "warning";
    Types["error"] = "error";
})(Types || (Types = {}));
//# sourceMappingURL=constants.js.map